import { Palette } from '@mui/material';

export const sliderOverrides = (palette: Palette) => ({
	root: {
		height: 8,
		paddingTop: 16,
		paddingBottom: 16,
		marginRight: 40,
		width: 'unset',
		display: 'block',
		transition: 'opacity 1s',
		'&.Mui-disabled': {
			opacity: 0.5
		},
		'@media (pointer: coarse)': {
			paddingTop: 16,
			paddingBottom: 16
		}
	},
	thumb: {
		width: 40,
		height: 40,
		marginLeft: 0,
		borderRadius: 20,
		backgroundColor: palette.primary.main,
		color: '#ffffff',
		boxShadow: 'none',
		transform: 'translate(0, -50%)',
		'&:focus, &:hover, &.Mui-focusVisible, &.Mui-active': {
			boxShadow: 'none'
		},
		'&.Mui-disabled': {
			width: 40,
			height: 40,
			marginLeft: 0
		},
		'&:before': {
			boxShadow: 'none'
		}
	},
	rail: {
		height: 8,
		borderRadius: 4,
		width: 'unset',
		left: 0,
		right: -40,
		color: '#C4C6C7'
	},
	track: {
		height: 8,
		borderRadius: 4,
		borderTopRightRadius: 0,
		borderBottomRightRadius: 0,
		color: palette.secondary.main,
		border: 'none'
	},
	thumbColorSecondary: {
		backgroundColor: palette.primary.main,
		'&:focus, &:hover, &$active': {
			boxShadow: 'none'
		}
	}
});
